import { z } from 'zod';
import { jsonValue } from '@common/utils/dynamicConfig/firebase/FirebaseValueSchemas';

/**
 * Determines how we handle contact form submissions.
 */
export interface IContactFormConfig {
  /**
   * Will store the submissions received in the local database if true.
   */
  saveSubmissions: boolean;

  /**
   * Where to send contact form submissions downstream.
   */
  downstreamSubmissionURLs: Record<string, string>;

  /**
   * After how many days we should automatically remove submissions from the DB
   */
  deleteSubmissionsAfterDays: number;
}

export const contactFormConfigDefaults: IContactFormConfig = {
  saveSubmissions: true,
  downstreamSubmissionURLs: {},
  deleteSubmissionsAfterDays: 30,
};

export const contactFormConfigSchema = jsonValue.pipe(
  z
    .object({
      saveSubmissions: z.boolean().default(contactFormConfigDefaults.saveSubmissions),
      downstreamSubmissionURLs: z
        .record(z.string(), z.string().url())
        .default(contactFormConfigDefaults.downstreamSubmissionURLs),
      deleteSubmissionsAfterDays: z.number().default(contactFormConfigDefaults.deleteSubmissionsAfterDays),
    })
    .default(contactFormConfigDefaults),
);
